import { ItemBonuses } from '../types/Item.types';
import { ITEM_DEFINITIONS } from '../data/items';
import { InventoryManager } from '../systems/InventoryManager';

// === HELPERS UI INVENTAIRE ===
// Constantes et fonctions partagées entre toutes les scènes d'inventaire.
// Évite la duplication de RARITY_COLORS, formatBonuses, etc.

/** Couleurs par rareté */
export const RARITY_COLORS: Record<string, string> = {
  common: '#bdc3c7',
  uncommon: '#2ecc71',
  rare: '#f1c40f',
};

/** Formate les bonus d'un item en texte compact */
export function formatBonuses(bonuses: Partial<ItemBonuses>): string {
  const parts: string[] = [];
  if (bonuses.attack) parts.push(`ATK${bonuses.attack > 0 ? '+' : ''}${bonuses.attack}`);
  if (bonuses.defense) parts.push(`DEF${bonuses.defense > 0 ? '+' : ''}${bonuses.defense}`);
  if (bonuses.maxHp) parts.push(`HP${bonuses.maxHp > 0 ? '+' : ''}${bonuses.maxHp}`);
  if (bonuses.pa) parts.push(`PA${bonuses.pa > 0 ? '+' : ''}${bonuses.pa}`);
  if (bonuses.pm) parts.push(`PM${bonuses.pm > 0 ? '+' : ''}${bonuses.pm}`);
  if (bonuses.range) parts.push(`PO+${bonuses.range}`);
  if (bonuses.capacity) parts.push(`+${bonuses.capacity} places`);
  return parts.join('  ');
}

/** Retourne la couleur d'un item par son definitionId */
export function getItemColor(definitionId: string): string {
  const def = ITEM_DEFINITIONS[definitionId];
  return RARITY_COLORS[def?.rarity] ?? '#ffffff';
}

/** Retourne la couleur numérique pour Phaser (bordures, etc.) */
export function getItemColorNum(definitionId: string): number {
  const hex = getItemColor(definitionId).replace('#', '');
  return parseInt(hex, 16);
}

/** Résumé texte du transport : "Sac (3/7)" */
export function transportSummary(inv: InventoryManager): string {
  return `🎒 ${inv.getTransportCount()}/${inv.getTransportCapacity()}`;
}

/** Résumé texte des consommables : "🧪 2/3" */
export function consumablesSummary(inv: InventoryManager): string {
  return `🧪 ${inv.getConsumables().length}/${inv.getMaxConsumables()}`;
}
